import { render, staticRenderFns } from "./xiayu.vue?vue&type=template&id=408f662d&scoped=true&"
import script from "./xiayu.vue?vue&type=script&lang=js&"
export * from "./xiayu.vue?vue&type=script&lang=js&"
import style0 from "./xiayu.vue?vue&type=style&index=0&id=408f662d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f662d",
  null
  
)

export default component.exports